// Author thq
// Date 2021-11-03 16:48:52

import * as model from "@/model/em/spareparts/EmSppLocationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppLocation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emSppLocation',
        modelFilter: model.filter
    })
    .buildStore()
